export function tebaDomainRedirect() {
  if (window.location.hostname.startsWith("prod-teba")) {
    const newHostname = window.location.hostname.replace("prod-teba", "teba");
    window.location.href = `${window.location.protocol}//${newHostname}${window.location.pathname}${window.location.search}${window.location.hash}`;
  }
}
